import { Button } from "@chakra-ui/react";

const DeleteButton = ({ buttonText, handleDelete, id }) => {
    return (
        <Button
            colorScheme={"red"}
            variant={"solid"}
            type='button'
            onClick={() => handleDelete(id)}
            w={{ base: "100%", sm: "auto" }}
            size={{ base: "sm", md: "sm" }}
        >
            {buttonText ? buttonText : '削除'}
        </Button>
    )
};

export default DeleteButton;